import { useContext, useMemo } from 'react';
import { GameDocumentContext } from '../../contexts/game-document';
import { PlayerContext } from '../../contexts/player';
import { GetResourceValue } from '../../utils/game-document/resources';

/**
 * Renders the game name.
 * @remarks Relies on game document context.
 */
export const GameName = () => {
  const [gameDocument] = useContext(GameDocumentContext);
  const [player] = useContext(PlayerContext);
  const titleResource = useMemo(
    () =>
      GetResourceValue(
        gameDocument.gameDocument!,
        gameDocument.gameDocument!.overview?.titleResId!,
        player?.playerState?.language?.name! ?? ''
      ),
    [gameDocument.gameCode]
  );
  return <>{titleResource}</>;
};
